import { render, staticRenderFns } from "./Houses.vue?vue&type=template&id=429931fb&scoped=true&"
import script from "./Houses.vue?vue&type=script&lang=js&"
export * from "./Houses.vue?vue&type=script&lang=js&"
import style0 from "./Houses.vue?vue&type=style&index=0&id=429931fb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429931fb",
  null
  
)

export default component.exports